import type { DataNode } from 'antd/es/tree';
import { NodeCard } from 'components/HierarchicalTrees/TreeNodeCard';

export const buildEntityToFunctionTree = (data: any[]): DataNode[] => {
  const entityMap = new Map<string, any>();
  const functionMap = new Map<string, any>();
  const serviceMap = new Map<string, any>();
  const systemMap = new Map<string, any>();

  const getOrCreate = (
    map: Map<string, any>,
    key: string,
    label: string,
    value: string,
    parent?: any,
    info?: any,
  ) => {
    if (!map.has(key)) {
      const node = {
        key,
        title: <NodeCard label={label} value={value} info={info} />,
        children: [],
      };

      map.set(key, node);
      if (parent) parent.children.push(node);
    }

    return map.get(key);
  };

  const createDataNode = (
    parent: any,
    key: string,
    value: string,
    info?: any,
  ) => {
    return getOrCreate(systemMap, key, 'Data', value, parent, info);
  };

  data.forEach((item) => {
    if (!item.entity_id) return;

    const entity = getOrCreate(
      entityMap,
      `entity-${item.entity_id}`,
      'Entity',
      item.name_of_entity || '',
    );

    const functionName = item.function_name || '';
    const serviceName = item.ict_service_name || '';

    const func = getOrCreate(
      functionMap,
      `entity-${item.entity_id}-function-${functionName}`,
      'Function',
      functionName,
      entity,
    );

    const service = getOrCreate(
      serviceMap,
      `entity-${item.entity_id}-function-${functionName}-service-${serviceName}`,
      'ICT Service',
      serviceName,
      func,
    );

    const systemId =
      item.function_ict_system_id || item.ict_service_ict_system_id;

    const systemName =
      item.function_ict_system_name || item.ict_service_ict_system_name || '';

    const functionSystem = getOrCreate(
      systemMap,
      `function-${func.key}-system-${systemId || ''}`,
      'ICT System',
      systemName,
      func,
    );

    const serviceSystem = getOrCreate(
      systemMap,
      `service-${service.key}-system-${systemId || ''}`,
      'ICT System',
      systemName,
      service,
    );

    const functionDataValue = item.function_data_description || '';
    const serviceDataValue = item.ict_service_data_description || '';

    createDataNode(
      functionSystem,
      `${functionSystem.key}-data-${item.function_data_id || ''}`,
      functionDataValue,
      {
        function_location_of_data_at_rest_name:
          item.function_location_of_data_at_rest_name,

        function_location_of_data_management_name:
          item.function_location_of_data_management_name,

        function_data_site: item.function_data_site,

        function_sensitiveness_of_data_stored_by_ict_tpsp_name:
          item.function_sensitiveness_of_data_stored_by_ict_tpsp_name,
      },
    );
    // SERVICE
    createDataNode(
      serviceSystem,
      `${serviceSystem.key}-data-${item.ict_service_data_id || ''}`,
      serviceDataValue,
      {
        ict_service_location_of_data_at_rest_name:
          item.ict_service_location_of_data_at_rest_name,

        ict_service_location_of_data_management_name:
          item.ict_service_location_of_data_management_name,

        ict_service_data_site: item.ict_service_data_site,

        ict_service_sensitiveness_of_data_stored_by_ict_tpsp_name:
          item.ict_service_sensitiveness_of_data_stored_by_ict_tpsp_name,
      },
    );
  });

  return Array.from(entityMap.values());
};
